export const Vector = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="23"
    height="20"
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{
      fill: "transparent",
    }}
    {...props}
  >
    <path
      d="M7.72565 11.6334L14.8121 5.54826L5.4432 9.84007L0.291736 5.79246C0.178581 5.70361 0.0926725 5.58319 0.0442492 5.44556C-0.00417414 5.30792 -0.0130691 5.15888 0.0186247 5.0162C0.0503184 4.87352 0.121264 4.74321 0.223004 4.64081C0.324744 4.53842 0.452988 4.46825 0.592448 4.43867L21.4701 0.015598C21.5923 -0.0102094 21.719 -0.00391417 21.8383 0.0339013C21.9576 0.0717169 22.0656 0.139832 22.1525 0.23195C22.2394 0.324067 22.3023 0.437213 22.3354 0.560926C22.3685 0.684639 22.3707 0.814927 22.3418 0.939743L18.2506 18.5527C18.2219 18.6764 18.1636 18.7908 18.081 18.8855C17.9984 18.9802 17.8941 19.0521 17.7775 19.0948C17.6609 19.1375 17.5358 19.1496 17.4136 19.1299C17.2913 19.1103 17.1758 19.0595 17.0774 18.9823L7.72565 11.6334ZM5.7803 17.7155L6.80123 12.804L10.8033 15.9794L6.90296 18.5191C6.77943 18.5995 6.63555 18.6407 6.48936 18.6374C6.34317 18.6341 6.20118 18.5865 6.0812 18.5006C5.96122 18.4147 5.86859 18.2943 5.81493 18.1545C5.76126 18.0147 5.74896 17.8617 5.77955 17.7148L5.7803 17.7155Z"
      fill="#783A22"
    />
  </svg>
);
